<template>
  <div id="app">
    <static-notice style="display: none"></static-notice>
    <div class="top">
      <div class="content">
        <div class="nav">
          <img alt="" src="./assets/logo.png" />
          <div class="nav-text">
            <div
              :class="{ active: active === 1 }"
              @mouseout="resetNav"
              @mouseover="hoverNav(1)"
            >
              {{ $t("menu.home") }}
            </div>
            <div
              :class="{ active: active === 2 }"
              @mouseout="resetNav"
              @mouseover="hoverNav(2)"
            >
              {{ $t("menu.appSign") }}
            </div>
            <div
              :class="{ active: active === 3 }"
              @mouseout="resetNav"
              @mouseover="hoverNav(3)"
            >
              {{ $t("menu.enterpriseSign") }}
            </div>
            <!--<div :class="{'active':active===4}" @mouseout="resetNav" @mouseover="hoverNav(4)">国际短信发送</div>
                        <div :class="{'active':active===5}" @mouseout="resetNav" @mouseover="hoverNav(5)">域名解封服务</div>-->
            <div
              :class="{ active: active === 6 }"
              @mouseout="resetNav"
              @mouseover="hoverNav(6)"
            >
              {{ $t("menu.aboutUs") }}
            </div>
          </div>

          <div class="langpic" @mouseout="hideLang" @mouseover="showLang">
            <img alt="" :src="langpicture" />
            <!-- <img src="./assets/cn.png" class=""> -->
          </div>

          <div
            @mouseout="hideLang"
            @mouseover="showLang"
            :class="{ lang: lang, 'hide-lang': !lang, 'switch-lang': true }"
          >
            <ul>
              <li class="cnlang">
                <div class="language">
                  <a href="javascript:void(0)" @click="changeLang('zh')">
                    <img src="./assets/cn.png" />
                    <span>简体中文</span>
                  </a>
                </div>
              </li>
              <li class="enlang">
                <div class="language">
                  <a href="javascript:void(0)" @click="changeLang('en')">
                    <img src="./assets/us.png" />
                    <span>English</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!--..........-->
        <div class="desc-area">
          <img
            :class="$t('enImageStyle')"
            alt=""
            src="./assets/banner_text_en.png"
          />
          <img
            :class="$t('cnImageStyle')"
            alt=""
            src="./assets/banner_text_zh.png"
          />
        </div>
        <!--按钮-->
        <div class="btn-area">
          <div
            :class="[reg ? 'btn-active' : 'btn-common']"
            @click="gotoReg"
            @mouseover="changeBtn('reg')"
          >
            {{ $t("buttons.registerNow") }}
          </div>
          <div
            :class="[!reg ? 'btn-active' : 'btn-common']"
            @click="gotoLogin"
            @mouseover="changeBtn('login')"
          >
            {{ $t("buttons.loginToPublish") }}
          </div>
        </div>
      </div>

      <!--返回顶部-->
      <div class="return-top">
        <div class="items">
          <a href="https://t.me/ios6868" target="_blank">
            <img alt="" src="./assets/side_tg.png" />
          </a>
          <a href="tencent://message/?uin=1052500005" target="_blank">
            <img alt="" src="./assets/side_qq.png" />
          </a>
          <a href="skype:1052500005?chat" target="_blank">
            <img alt="" src="./assets/side_skype.png" />
          </a>
          <a href="https://wa.me/639958827295" target="_blank">
            <img alt="" src="./assets/side_whats_app.png" />
          </a>
          <div @click="gotoTop">
            <img alt="" src="./assets/side_top.png" />
          </div>
        </div>
      </div>

      <!--操作步骤-->
      <div class="action">
        <div class="action-title">{{ $t("steps.stepsClear") }}</div>
        <div class="action-area">
          <div class="action-logo">
            <div>
              <img alt="" src="./assets/step_01.png" />
              <div class="action-text">{{ $t("steps.cooperation") }}</div>
            </div>
            <div>
              <img alt="" src="./assets/step_02.png" />
              <div class="action-text">{{ $t("steps.uploadAppPackage") }}</div>
            </div>
            <div>
              <img alt="" src="./assets/step_03.png" />
              <div class="action-text">{{ $t("steps.signSuccessfully") }}</div>
            </div>
            <div>
              <img alt="" src="./assets/step_04.png" />
              <div class="action-text">{{ $t("steps.recharge") }}</div>
            </div>
            <div>
              <img alt="" src="./assets/step_05.png" />
              <div class="action-text">{{ $t("steps.exclusiveLinks") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--优势-->
      <div class="advance">
        <div class="advance-title">{{ $t("adnvantages.fourAdvantages") }}</div>
        <div class="advance-area">
          <div class="advence-item">
            <img alt="" src="./assets/four_01.png" />
            <div class="advance-right">
              <div class="advance-top">
                {{ $t("adnvantages.firstOnNetwork") }}
              </div>
              <div class="advance-bottom">
                {{ $t("adnvantages.firstOnNetworkDescription") }}
              </div>
            </div>
          </div>
          <div class="advence-item">
            <img alt="" src="./assets/four_02.png" />
            <div class="advance-right">
              <div class="advance-top">
                {{ $t("adnvantages.installAndUse") }}
              </div>
              <div class="advance-bottom">
                {{ $t("adnvantages.installAndUseDescription") }}
              </div>
            </div>
          </div>
          <div class="advence-item">
            <img alt="" src="./assets/four_03.png" />
            <div class="advance-right">
              <div class="advance-top">
                {{ $t("adnvantages.costEeffective") }}
              </div>
              <div class="advance-bottom">
                {{ $t("adnvantages.costEeffectiveDescription") }}
              </div>
            </div>
          </div>
          <div class="advence-item">
            <img alt="" src="./assets/four_04.png" />
            <div class="advance-right">
              <div class="advance-top">{{ $t("adnvantages.oneToOne") }}</div>
              <div class="advance-bottom">
                {{ $t("adnvantages.oneToOneDescription") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--优点-->
      <div class="merit">
        <div class="merit-title">
          {{ $t("differences.differentFeaturesPC") }}
        </div>
        <div class="merit-area">
          <div class="merit-item">
            <div class="merit-block">
              <img alt="" src="./assets/advantage_01.png" />
              <div class="merit-text">{{ $t("differences.difference1") }}</div>
            </div>
            <div class="merit-block">
              <img alt="" src="./assets/advantage_02.png" />
              <div class="merit-text">{{ $t("differences.difference2") }}</div>
            </div>
            <div class="merit-block">
              <img alt="" src="./assets/advantage_03.png" />
              <div class="merit-text">{{ $t("differences.difference3") }}</div>
            </div>
          </div>
          <div class="merit-item">
            <div class="merit-block">
              <img alt="" src="./assets/advantage_04.png" />
              <div class="merit-text">{{ $t("differences.difference4") }}</div>
            </div>
            <div class="merit-block">
              <img alt="" src="./assets/advantage_05.png" />
              <div class="merit-text">{{ $t("differences.difference5") }}</div>
            </div>
            <div class="merit-block">
              <img alt="" src="./assets/advantage_06.png" />
              <div class="merit-text">{{ $t("differences.difference6") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--合作伙伴-->
      <div class="coor">
        <div class="coor-title">{{ $t("partners") }}</div>
        <div class="coor-area">
          <div class="coor-item">
            <div class="coor-block"></div>
            <div class="coor-block"></div>
            <div class="coor-block"></div>
            <div class="coor-block"></div>
          </div>
          <div class="coor-item">
            <div class="coor-block"></div>
            <div class="coor-block"></div>
            <div class="coor-block"></div>
            <div class="coor-block"></div>
          </div>
        </div>
      </div>

      <!--底部-->
      <div class="foot">
        <div class="foot-area">
          <div class="foot-logo">
            <img alt="" src="./assets/logo2.png" />
          </div>
          <div class="foot-bottom">
          <a
                className="link"
                rel="noopener noreferrer"
                target="_blank"
                href="https://beian.miit.gov.cn/"
                style="color: #fff"
            >
            沪ICP备2023012291号-24
            </a>
        </div>
          <div class="foot-right">
            <div class="foot-item">
              <div class="foot-label">{{ $t("companyName") }}:</div>
              <div class="foot-text">DVS Software Incorporated</div>
            </div>
            <div class="foot-item">
              <div class="foot-label">{{ $t("address") }}:</div>
              <div class="foot-text">
                100 GOODWOOD PARK COURT #405 TORONTO, ON, Canada M4C 2G7
              </div>
            </div>
            <div class="foot-item">
              <div class="foot-label">{{ $t("phone") }}:</div>
              <div class="foot-text">6841696</div>
            </div>
            <div class="foot-item">
              <div class="foot-label">{{ $t("industry") }}:</div>
              <div class="foot-text">{{ $t("industryValue") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--**********************手机版*************************-->
    <div @click="hidePanel" class="mobile">
      <div class="nav">
        <div class="logo"></div>
        <div @click="showDrawer" class="btn-menu">
          <img alt="" src="./assets/m/menu@3x.png" />
        </div>
        <div id="langPanel" class="langpic-mobile">
          <a href="javascript:void(0)" @click="showLangPicker"
            ><img alt="" :src="langpicture"
          /></a>
        </div>
        <div :class="{ lang: lang, 'hide-lang': !lang, 'switch-lang': true }">
          <ul>
            <li class="cnlang">
              <div class="language">
                <a href="javascript:void(0)" @click="changeLang('zh')">
                  <img src="./assets/cn.png" />
                  <span>简体中文</span>
                </a>
              </div>
            </li>
            <li class="enlang">
              <div class="language">
                <a href="javascript:void(0)" @click="changeLang('en')">
                  <img src="./assets/us.png" />
                  <span>English</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="desc-area">
          <img
            :class="$t('enImageStyle')"
            alt=""
            src="./assets/m/banner-text-en@3x.png"
          />
          <img
            :class="$t('cnImageStyle')"
            alt=""
            src="./assets/m/banner-text-zh@3x.png"
          />
        </div>

        <!--按钮-->
        <div @click="gotoReg" class="btn-reg">
          {{ $t("buttons.registerNow") }}
        </div>
        <div @click="gotoLogin" class="btn-login">
          {{ $t("buttons.loginToPublish") }}
        </div>
      </div>

      <!--操作-->
      <div class="action">
        <div class="action-title">{{ $t("steps.stepsClear") }}</div>
        <div class="action-area">
          <div class="action-item">
            <div class="action-block-left">
              <img alt="" src="./assets/m/icon-step@3x1.png" />
              <div>{{ $t("steps.cooperation") }}</div>
            </div>
            <div class="action-block-right">
              <img alt="" src="./assets/m/icon-step@3x2.png" />
              <div>{{ $t("steps.uploadAppPackage") }}</div>
            </div>
          </div>
          <div class="action-item">
            <div class="action-block-left">
              <img alt="" src="./assets/m/icon-step@3x3.png" />
              <div>{{ $t("steps.signSuccessfully") }}</div>
            </div>
            <div class="action-block-right">
              <img alt="" src="./assets/m/icon-step@3x4.png" />
              <div>{{ $t("steps.recharge") }}</div>
            </div>
          </div>
          <div class="action-item">
            <div class="action-block-left">
              <img alt="" src="./assets/m/icon-step@3x5.png" />
              <div>{{ $t("steps.exclusiveLinks") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--优势-->
      <div class="advance">
        <div class="adv-title">
          {{ $t("adnvantages.fourAdvantages") }}
        </div>

        <div class="adv-item">
          <img alt="" src="./assets/m/icon-four@3x1.png" />
          <div class="adv-right">
            <div class="adv-top">{{ $t("adnvantages.firstOnNetwork") }}</div>
            <div class="adv-bottom">
              {{ $t("adnvantages.firstOnNetworkDescription") }}
            </div>
          </div>
        </div>
        <div class="adv-item">
          <img alt="" src="./assets/m/icon-four@3x2.png" />
          <div class="adv-right">
            <div class="adv-top">{{ $t("adnvantages.installAndUse") }}</div>
            <div class="adv-bottom">
              {{ $t("adnvantages.installAndUseDescription") }}
            </div>
          </div>
        </div>
        <div class="adv-item">
          <img alt="" src="./assets/m/icon-four@3x3.png" />
          <div class="adv-right">
            <div class="adv-top">{{ $t("adnvantages.costEeffective") }}</div>
            <div class="adv-bottom">
              {{ $t("adnvantages.costEeffectiveDescription") }}
            </div>
          </div>
        </div>
        <div class="adv-item">
          <img alt="" src="./assets/m/icon-four@3x4.png" />
          <div class="adv-right">
            <div class="adv-top">{{ $t("adnvantages.oneToOne") }}</div>
            <div class="adv-bottom">
              {{ $t("adnvantages.oneToOneDescription") }}
            </div>
          </div>
        </div>
      </div>

      <!--优点-->
      <div class="four">
        <div class="four-title">
          {{ $t("differences.differentFeaturesCN1") }}
        </div>
        <div class="four-title">
          {{ $t("differences.differentFeaturesCN2") }}
        </div>
        <div class="fout-subtitle">
          {{ $t("differences.differentFeaturesEN") }}
        </div>

        <div class="four-item">
          <div class="four-block-left">
            <img alt="" src="./assets/m/icon-advantage@3x1.png" />
            <div class="four-text">
              {{ $t("differences.difference1") }}
            </div>
          </div>
          <div class="four-block-right">
            <img alt="" src="./assets/m/icon-advantage@3x2.png" />
            <div class="four-text">
              {{ $t("differences.difference2") }}
            </div>
          </div>
        </div>
        <div class="four-item">
          <div class="four-block-left">
            <img alt="" src="./assets/m/icon-advantage@3x3.png" />
            <div class="four-text">
              {{ $t("differences.difference3") }}
            </div>
          </div>
          <div class="four-block-right">
            <img alt="" src="./assets/m/icon-advantage@3x4.png" />
            <div class="four-text">
              {{ $t("differences.difference4") }}
            </div>
          </div>
        </div>
        <div class="four-item">
          <div class="four-block-left">
            <img alt="" src="./assets/m/icon-advantage@3x5.png" />
            <div class="four-text">
              {{ $t("differences.difference5") }}
            </div>
          </div>
          <div class="four-block-right">
            <img alt="" src="./assets/m/icon-advantage@3x6.png" />
            <div class="four-text">
              {{ $t("differences.difference6") }}
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
      <!--合作伙伴-->
      <div class="coor">
        <div class="coor-title">{{ $t("partners") }}</div>
        <div class="coor-item">
          <div class="coor-block-left"></div>
          <div class="coor-block-right"></div>
        </div>
        <div class="coor-item">
          <div class="coor-block-left"></div>
          <div class="coor-block-right"></div>
        </div>
        <div class="coor-item">
          <div class="coor-block-left"></div>
          <div class="coor-block-right"></div>
        </div>
        <div class="coor-item">
          <div class="coor-block-left"></div>
          <div class="coor-block-right"></div>
        </div>
      </div>

      <!--底部-->
      <div class="foot">
        <div class="foot-top">
          <img alt="" src="./assets/m/logo@3x3.png" />
        </div>
        
        <div class="foot-bottom">
          <a
                className="link"
                rel="noopener noreferrer"
                target="_blank"
                href="https://beian.miit.gov.cn/"
                style="color: #fff"
            >
            沪ICP备2023012291号-24
            </a>
        </div>
        <!--联系方式-->
        <div class="foot-area">
          <div class="foot-item">
            <div class="foot-left">{{ $t("companyName") }}:</div>
            <div class="foot-right">DVS Software Incorporated</div>
          </div>
          <div style="clear: both"></div>
          <div class="foot-item">
            <div class="foot-left">{{ $t("address") }}:</div>
            <div class="foot-right foot-add">
              100 GOODWOOD PARK COURT #405 TORONTO, ON, Canada M4C 2G7
            </div>
          </div>
          <div style="clear: both"></div>
          <div class="foot-item">
            <div class="foot-left">{{ $t("phone") }}:</div>
            <div class="foot-right">6841696</div>
          </div>
          <div style="clear: both"></div>
          <div class="foot-item">
            <div class="foot-left">{{ $t("industry") }}:</div>
            <div class="foot-right">{{ $t("industryValue") }}</div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <!--固定-->
      <div class="fix">
        <div class="items">
          <a href="https://t.me/ios6868" target="_blank">
            <img alt="" src="./assets/side_tg.png" />
          </a>
          <a href="tencent://message/?uin=1052500005" target="_blank">
            <img alt="" src="./assets/side_qq.png" />
          </a>
          <a href="skype:1052500005?chat" target="_blank">
            <img alt="" src="./assets/side_skype.png" />
          </a>
          <a href="https://wa.me/639958827295" target="_blank">
            <img alt="" src="./assets/side_whats_app.png" />
          </a>
          <div @click="gotoTop">
            <img alt="" src="./assets/side_top.png" />
          </div>
        </div>
      </div>

      <div style="clear:both;"></div>

      <!--侧边抽屉-->
      <div @touchmove.prevent class="drawer" v-if="drawer">
        <div class="drawer-content">
          <div class="drawer-logo">
            <img alt="" src="./assets/m/logo@3x_1.png" />
          </div>
          <div @click="gotoNav(1)" class="drawer-item">
            {{ $t("menu.home") }}
          </div>
          <div @click="gotoNav(2)" class="drawer-item">
            {{ $t("menu.appSign") }}
          </div>
          <div @click="gotoNav(3)" class="drawer-item">
            {{ $t("menu.enterpriseSign") }}
          </div>
          <div @click="gotoNav(4)" class="drawer-item">
            {{ $t("menu.aboutUs") }}
          </div>
        </div>
        <div @click="hideDrawer" class="drawer-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import StaticNotice from "@/components/staticNotice";
export default {
  name: "app",
  components: {
    StaticNotice,
  },
  data() {
    return {
      active: 1,
      qq: false,
      reg: false,
      drawer: false,
      lang: false,
      langpicture:
        localStorage.getItem("lang") == "zh"
          ? require("./assets/cn.png")
          : require("./assets/us.png"),
    };
  },
  mounted() {},
  methods: {
    hoverNav(index) {
      this.active = index;
    },
    resetNav() {
      this.active = 1;
    },
    showQQ() {
      this.qq = true;
    },
    hideQQ() {
      this.qq = false;
    },
    toggleQQ() {
      this.qq = !this.qq;
    },
    gotoTop() {
      window.scrollTo(0, 0);
    },
    gotoReg() {
      window.location.href = "/index/register";
    },
    gotoLogin() {
      window.location.href = "/index/login";
    },
    changeBtn(value) {
      if (value === "reg") {
        this.reg = true;
      } else {
        this.reg = false;
      }
    },
    showLangPicker() {
      if (this.lang === false) {
        this.lang = true;
      } else {
        this.lang = false;
      }
    },
    showLang() {
      this.lang = true;
    },
    hideLang() {
      this.lang = false;
    },
    hidePanel(event) {
      var sp = document.getElementById("langPanel");
      if (sp) {
        if (!sp.contains(event.target)) {
          this.lang = false;
        }
      }
    },
    showDrawer() {
      document.body.style.overflow = "hidden";
      this.drawer = true;
    },
    changeLang(value) {
      localStorage.setItem("lang", value);
      location.reload();
    },
    hideDrawer() {
      document.body.style.overflow = "scroll";
      this.drawer = false;
    },
    gotoNav(value) {
      switch (value) {
        case 1:
          window.location.href = "/";
          break;
        case 2:
          window.location.href = "/index/login";
          break;
        case 3:
          window.location.href = "/index/login";
          break;
        case 4:
          break;
      }
    },
  },
};
</script>

<style>
@import "assets/index.css";
</style>
